import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {BlogListComponent} from './components/blog-list/blog-list.component';
import {BlogFormComponent} from './components/blog-form/blog-form.component';
import {BlogCategoriesComponent} from './components/blog-categories/blog-categories.component';
import {BlogTagsComponent} from './components/blog-tags/blog-tags.component';

const routes: Routes = [
    {path: 'blogs', component: BlogListComponent},
    {path: 'blogs/new', component: BlogFormComponent},
    {path: 'blogs/categories', component: BlogCategoriesComponent},
    {path: 'blogs/tags', component: BlogTagsComponent},
    {path: 'blogs/:id/edit', component: BlogFormComponent}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BlogRoutingModule {
}
